import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { graphql, useFragment } from 'react-relay';

import type { PaymentCheckoutTitle_checkout$key } from './__generated__/PaymentCheckoutTitle_checkout.graphql.ts';

import type { ReactNode } from 'react';

const PaymentCheckoutTitle = (props): ReactNode => {
  const theme = useTheme();

  const checkout = useFragment<PaymentCheckoutTitle_checkout$key>(
    graphql`
      fragment PaymentCheckoutTitle_checkout on Checkout {
        title
      }
    `,
    props.checkout,
  );

  return (
    <Stack
      sx={{
        p: theme.spacing(2),
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
      }}
    >
      <Typography
        variant={'subtitle1'}
        sx={{
          fontSize: theme.typography.pxToRem(18),
          color: theme?.palette?.text?.secondary,
          textAlign: 'center',
        }}
      >
        {checkout.title}
      </Typography>
    </Stack>
  );
};

export default PaymentCheckoutTitle;
